<!-- 宏观决策影响因素分值表 -->
<template>
  <d2-container>
    <div v-show="!showTabFom">
      <el-row style="margin-bottom: 20px">
        <el-col :span="4">
          <popover-form popoverWidth="680" :formConfig="advSearch" v-model="searchForm" @onSubmit="searchTable"></popover-form>
        </el-col>
        <el-col :span="20">
            <div class="text-align_right">
                <el-button type="primary" @click="addRow">新增</el-button>
            </div>
        </el-col>
      </el-row>
      <div>
        <dynamic-table
          :tableSet="tableSet"
          :tableData="tableData"
          :pageIndex="pageIndex"
          :pageShow="false"
          :pageShowX = "true"
          @goPageIndex="goPageIndex"
          :pageCount="pageCount"
          @rowClick="rowClick(row)"
        ></dynamic-table>
      </div>
    </div>
    <div v-show="showTabFom">
      <div>
        <div>
          <div class="text-align_right">
              <el-button-group>
                <el-button type="primary" v-if="(operationType==1||operationType==2)" @click="dataSubmit" >保存</el-button>
                <el-button type="primary" @click="close">返回</el-button>
              </el-button-group>
          </div>
          <divider title="宏观决策影响因素分值明细" />
          <dynamic-form ref="form" :formConfig="formConfig" :disabled="!(operationType==1||operationType==2)" v-model="form"></dynamic-form>
        </div>
      </div>
    </div>
    <template slot="footer" v-if="showTabFom">
      <billing-info :billingInfo="form"></billing-info>
    </template>
  </d2-container>
</template>
<script>
export default {
  name: "pmdInfluenceFactorc",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      initializeForm:{},
      showTabFom: false, //表格表单转换状态
      operationType: 1, //主表操作状态

      searchForm: {
          factorCategories:"",
          parameterType:"",
          classifySth:"",
      },
      advSearch: {
        list: [
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "",
              "multiple": false,
              "disabled": false,
              "clearable": false,
              "placeholder": "请选择",
              "required": false,
              "requiredMessage": "",
              "showLabel": false,
              "width": "250px",
              "options": [
                {
                  "label": "基本因素",
                  "value": "基本因素"
                },
                {
                  "label": "地区因素",
                  "value": "地区因素",
                },
                {
                  "label": "状况因素",
                  "value": "状况因素",
                },
                {
                  "label": "政策因素",
                  "value": "政策因素",
                }
              ],
              "remote": false,
              "remoteType": "option",
              "remoteOption": "option_1592379504496",
              "filterable": false,
              "remoteOptions": [],
              "props": {
                "value": "value",
                "label": "label"
              },
              "remoteFunc": "func_1592379504496",
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true
            },
            "name": "类别",
            "key": "factorCategories",
            "model": "factorCategories",
            "rules": [
              {
                "required": false,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "input",
            "icon": "icon-input",
            "options": {
              "width": "250px",
              "defaultValue": "",
              "required": false,
              "requiredMessage": "",
              "dataType": "string",
              "dataTypeCheck": false,
              "dataTypeMessage": "",
              "pattern": "",
              "patternCheck": false,
              "patternMessage": "",
              "placeholder": "",
              "customClass": "",
              "disabled": false,
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true,
              "showPassword": false,
              "remoteFunc": "func_1592378626642",
              "remoteOption": "option_1592378626642"
            },
            "name": "因素类别",
            "key": "parameterType",
            "model": "parameterType",
            "rules": [
              {
                "required": false,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "input",
            "icon": "icon-input",
            "options": {
              "width": "250px",
              "defaultValue": "",
              "required": false,
              "requiredMessage": "",
              "dataType": "string",
              "dataTypeCheck": false,
              "dataTypeMessage": "",
              "pattern": "",
              "patternCheck": false,
              "patternMessage": "",
              "placeholder": "",
              "customClass": "",
              "disabled": false,
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true,
              "showPassword": false,
              "remoteFunc": "func_1592378626642",
              "remoteOption": "option_1592378626642"
            },
            "name": "影响因素内容",
            "key": "classifySth",
            "model": "classifySth",
            "rules": [
              {
                "required": false,
                "message": "必须填写"
              }
            ]
          },
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
      tableSet: {
        tableColumn: [
          {
            prop: "factorCategories",
            label: "类别"
          },{
            prop: "parameterType",
            label: "因素类别"
          },{
            prop: "classifySth",
            label: "影响因素内容"
          },{
            prop: "factorValue",
            label: "默认因素值"
          },{
            prop: "remark",
            label: "备注"
          },
        ],
        tableColBtn: [
          {
            show: true,
            size: "mini",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-view",
            title: "查看",
            name: "查看",
            click: this.rowClick
          },
          {
            show: true,
            size: "mini",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-edit",
            title: "编辑",
            name: "编辑",
            click: this.edit
          },
          {
          show: true,
          size:'mini',
          type:'danger',
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          icon:'el-icon-delete',
          title:'删除',
          name:'删除',
          click: this.del
        }
        ]
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      form: {
        rowCode :0,/// 主键  int
        type :'',/// 类别
        factorCategories :'',/// 影响因素类别
        classifySth :'',/// 分类别  
        parameterType :'',/// 参数类型
        factorValue :0,/// 默认因素值  int
        remark :'',/// 备注
        createUser :'',
        createUserName :'',
        createTime :'',
        updateUser :'',
        updateUserName :'',
        updateTime :'',
        r1 :'',
        r2 :'',
        r3 :'',
        r4 :'',
        r5 :'',
      },
      formConfig: {
        list: [
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "",
              "multiple": false,
              "disabled": false,
              "clearable": false,
              "placeholder": "请选择",
              "required": true,
              "requiredMessage": "",
              "showLabel": false,
              "width": "250px",
              "options": [
                {
                  "label": "基本因素",
                  "value": "基本因素"
                },
                {
                  "label": "地区因素",
                  "value": "地区因素",
                },
                {
                  "label": "状况因素",
                  "value": "状况因素",
                },
                {
                  "label": "政策因素",
                  "value": "政策因素",
                }
              ],
              "remote": false,
              "remoteType": "option",
              "remoteOption": "option_1592379504496",
              "filterable": false,
              "remoteOptions": [],
              "props": {
                "value": "value",
                "label": "label"
              },
              "remoteFunc": "func_1592379504496",
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true
            },
            "name": "类别",
            "key": "factorCategories",
            "model": "factorCategories",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "input",
            "icon": "icon-input",
            "options": {
              "width": "250px",
              "defaultValue": "",
              "required": true,
              "requiredMessage": "",
              "dataType": "string",
              "dataTypeCheck": false,
              "dataTypeMessage": "",
              "pattern": "",
              "patternCheck": false,
              "patternMessage": "",
              "placeholder": "",
              "customClass": "",
              "disabled": false,
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true,
              "showPassword": false,
              "remoteFunc": "func_1592378626642",
              "remoteOption": "option_1592378626642"
            },
            "name": "因素类别",
            "key": "parameterType",
            "model": "parameterType",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "input",
            "icon": "icon-input",
            "options": {
              "width": "250px",
              "defaultValue": "",
              "required": true,
              "requiredMessage": "",
              "dataType": "string",
              "dataTypeCheck": false,
              "dataTypeMessage": "",
              "pattern": "",
              "patternCheck": false,
              "patternMessage": "",
              "placeholder": "",
              "customClass": "",
              "disabled": false,
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true,
              "showPassword": false,
              "remoteFunc": "func_1592378626642",
              "remoteOption": "option_1592378626642"
            },
            "name": "影响因素内容",
            "key": "classifySth",
            "model": "classifySth",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "number",
            "icon": "icon-number",
            "options": {
              "width": "250px",
              "required": true,
              "requiredMessage": "",
              "defaultValue": 0,
              "min": 0,
              "max": 999999999,
              "step": 1,
              "disabled": false,
              "controlsPosition": "",
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true,
              "remoteFunc": "func_1592379121337",
              "remoteOption": "option_1592379121337"
            },
            "name": "默认因素值",
            "key": "factorValue",
            "model": "factorValue",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            type: "textarea",
            icon: "icon-diy-com-textarea",
            options: {
              width: "500px",
              defaultValue: "",
              required: false,
              disabled: false,
              pattern: "",
              placeholder: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573374813695"
            },
            name: "备注",
            novalid: {},
            key: "1573374813695",
            model: "remark",
            rules: []
          }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    /********字典获取 ******/
    getDiction(target, targets) {
        let name = target.form.name;
        this.$http.post(this.$url.getDict, { search: name }).then(res => {
            let { data } = res;
            target.setList(data);
        });
    },
    /*******获取表格数据*****/
    getTableData() {
        let that = this;
        this.$http.postHandle('',this.$url.routeDecision.getinfluencefactors, { type:"3", ...that.searchForm, pageIndex:this.pageIndex, pageSize:this.pageSize }).then(res => {
            this.tableData = res.data;
            this.pageCount = res.pageCount;
        });
    },
    addRow() {//新增
      this.showTabFom = true;
      this.operationType = 1;
      this.resetForm("form");
    },
    searchTable(){//查询
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    goPageIndex(pageIndex,pageSize) {//分页
      this.pageIndex = pageIndex;
      this.pageSize = pageSize
      this.getTableData();
    },
    rowClick(row) {//查看
        this.operationType = 3;
        this.form = this.$formSetForm(this.form,row);
        this.showTabFom = true;
    },
    edit(row, index) {//编辑
        this.operationType = 2;
        this.form = this.$formSetForm(this.form,row);
        this.showTabFom = true;
    },
    del(row, index) {//删除
      let form = row;
      this.$msgDel(this.$url.routeDecision.operationinfluencefactor, { influenceFactor: form, operationType: 8 }).then(res => {
        if((this.tableData.length<=1)&&(this.pageIndex>1)){
          this.pageIndex=this.pageIndex-1;
        }
        this.getTableData();
      });
    },
    dataSubmit() {//保存
        this.$refs.form.submit().then(res => {
            let form = this.$formSetForm(this.form, this.form);
            form.type="3";
            this.$http.postHandle("保存", this.$url.routeDecision.operationinfluencefactor, { influenceFactor: form, operationType: this.operationType }).then(res => {
                this.showTabFom = false;
                this.getTableData();
            });
        });
    },
    close() {//返回
      this.$closePage(this.operationType).then(() => {
        this.showTabFom = false;
        this.getTableData();
      });
    },
    resetForm(formName) {//重置
      let that = this;
      this.form = this.$formSetForm(this.initializeForm , this.initializeForm)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getTableData();
    this.initializeForm = this.$formSetForm(this.form , this.form)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/macroDecisionMaking/pmdInfluenceFactorc.vue"
}
</vue-filename-injector>
